import React from 'react';
import { Box, Pagination } from '@drone-js/core';
import { connect } from 'react-redux';
import { mapDispatchToPaginationProps, mapStateToPropsReviewPagination, ReviewPaginationProps } from 'component/page/detail/Review/Review.selectors';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesReviewPaginationNavBtnClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesReviewPaginationNavBtnClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';

const ReviewPaginationComponent: React.FC<ReviewPaginationProps> = (props) => {
    const { onPaginationClickCreator, activityId, currentFilter, currentSort } = props;
    const onPaginationClick = React.useMemo(
        () => onPaginationClickCreator(activityId, props.reviewSectionHref, currentSort, currentFilter),
        [activityId, onPaginationClickCreator, props.reviewSectionHref, currentSort, currentFilter],
    );

    if (props.isLoading || props.currentPageIndex === undefined || !props.maxPageNumber) {
        return null;
    }
    const onChange = (index: number) => {
        if (!props.pagination || !props.pagination.size || !(props.pagination.size > 0)) return;

        trackElementEvent<ActivitiesReviewPaginationNavBtnClickEventActivitiesFieldsV1>(ActivitiesReviewPaginationNavBtnClickEventActivitiesManifestV1.ids, {
            page_number: index + 1,
        });
        onPaginationClick(index + 1, props.pagination.size);
    };

    return (
        <Box data-testid="review-pagination-container" display="flex" justifyContent="center">
            {/* eslint-disable-next-line @agoda/agoda-a11y/no-incorrect-props -- @agoda/agoda-a11y/no-incorrect-props[d3dced24-781d-4dde-9e5c-07f22c74ce1d] */}
            <Pagination
                count={props.maxPageNumber}
                current={props.currentPageIndex}
                onChange={onChange}
                previousLabel={props.cms[130923]}
                nextLabel={props.cms[130706]}
                fastBackwardLabel={props.cms[5275]}
                fastForwardLabel={props.cms[5277]}
            />
        </Box>
    );
};

ReviewPaginationComponent.displayName = 'ReviewPagination';
const ReviewPagination = connect(mapStateToPropsReviewPagination, mapDispatchToPaginationProps)(ReviewPaginationComponent);
export default ReviewPagination;
